export default (state = {}, action = {}) => {
	if (action.type === 'PRODUCT_CACHE') {
		const { products, filterArrays, filterDescriptions, localized, searchTerms } = action.productCache;
		const depictKeys = {};
		const centraCategoryIds = Object.keys(action.categoryData.en).reduce((acc, key) => {
			acc[action.categoryData.en[key]] = key;
			return acc;
		}, {});

		// flatten multi-dimensional arrays on children
		const depictFlattened = (arr = [], parentSlugs = []) => {
			arr.forEach((depictListing) => {
				let uri = centraCategoryIds[depictListing.external_id] || [...parentSlugs, depictListing.slug].join('/');
				if (depictListing.listing_type !== 'category') uri = depictListing.listing_id;

				depictKeys[uri] = { title: depictListing.title, listingId: depictListing.listing_id, productOrder: [] };

				if (depictListing.children) {
					depictFlattened(depictListing.children, [...parentSlugs, depictListing.slug]);
				} else {
					parentSlugs = [];
				}
			});
		};

		depictFlattened(action.depictListings);

		return {
			...state,
			[action.market]: {
				...state[action.market],
				[action.pricelist]: {
					products,
					filterArrays,
					depictKeys,
					filterDescriptions,
					localized,
					searchTerms,
				},
			},
		};
	}

	if (action.type === 'PRODUCT_CACHE_UPDATE') {
		return {
			...state,
			[action.market]: {
				...state[action.market],
				[action.pricelist]: {
					...state[action.market][action.pricelist],
					filterArrays: {
						...state[action.market][action.pricelist].filterArrays,
						categories: {
							...state[action.market][action.pricelist].filterArrays.categories,
							[action.category]: [...action.depictProductOrder.map((id) => parseInt(id.replace('id_', ''), 10))],
						},
					},
					depictKeys: {
						...state[action.market][action.pricelist].depictKeys,
						[action.category]: {
							...state[action.market][action.pricelist].depictKeys[action.category],
							productOrder: { ...action.depictProductCache },
						},
					},
				},
			},
		};
	}

	return state;
};
